export default __webpack_public_path__ + "static/media/addProduct.7920fb0f.jpg";